var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.$t('Home.services.doctor.title'),"description":_vm.$t('Home.services.doctor.content')}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }